import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Carousel,
    CarouselItem,
    CarouselIndicators,
} from "reactstrap";
import Axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";

// Import Navbar, Header, Footer components
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import DcarePageHeader from "../../components/Headers/DcarePageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import dcare from "assets/img/BABIES & KIDS CARE UNIT (1).png";

import youtube from "assets/img/youtube.png";
import instagram from "assets/img/instagram.png";
import website from "assets/img/world-wide-web.png";
const DcarePage = () => {
    const [data, setData] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        // Initialize AOS animations
        AOS.init({ duration: 700, easing: "ease-in-out", once: true });

        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        fetchDcareData();

        return () => {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    const fetchDcareData = async () => {
        try {
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/dcare/readDcare`);
            setData(response.data[0]);
        } catch (error) {
            console.error("Error fetching Dcare data:", error);
        }
    };

    if (!data) {
        return <div>Loading...</div>;
    }

    const {
        penjelasan,
        foto_1,
        foto_2,
        foto_3,
        foto_4,
        foto_5,
        foto_6,
        link_web,
        link_yt,
        link_ig,
    } = data;

    const images = [foto_1, foto_2, foto_3, foto_4, foto_5, foto_6].filter(Boolean);

    const onExiting = () => setAnimating(true);
    const onExited = () => setAnimating(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    return (
        <>
            {/* Navbar */}
            <ExamplesNavbar />

            {/* Page Header */}
            <DcarePageHeader />

            {/* Main Content */}
            <div className="wrapper">
                <section className="dcare">
                    <Container className="container-dcare">
                        <Row className="my-4">
                            <Col data-aos="fade-right">
                                <div className="text-center mb-4">
                                    <img
                                        src={dcare}
                                        alt="dcare"
                                        className="img-fluid"
                                        style={{ width: "40%" }}
                                    />
                                </div>
                                <p>{penjelasan}</p>
                            </Col>
                        </Row>

                        {/* Social media links */}
                        <Row className="link-container justify-content-center" data-aos="fade-up">
                            <Col xs="auto">
                                <a href={link_web} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={website}
                                        alt="Website"
                                        style={{
                                            width: "32px",
                                            height: "32px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                </a>
                            </Col>
                            <Col xs="auto">
                                <a href={link_yt} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={youtube}
                                        alt="YouTube"
                                        style={{
                                            width: "32px",
                                            height: "32px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                </a>
                            </Col>
                            <Col xs="auto">
                                <a href={link_ig} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={instagram}
                                        alt="Instagram"
                                        style={{
                                            width: "32px",
                                            height: "32px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                </a>
                            </Col>
                        </Row>

                        {/* Carousel Section */}
                        <Row className="justify-content-center">
                            <Col
                                lg="6"
                                md="10"
                                data-aos="fade-left"
                                style={{ marginBottom: "30px" }}
                            >
                                <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                                    <CarouselIndicators
                                        items={images}
                                        activeIndex={activeIndex}
                                        onClickHandler={goToIndex}
                                    />
                                    {images.map((image, index) => (
                                        <CarouselItem
                                            onExiting={onExiting}
                                            onExited={onExited}
                                            key={index}
                                        >
                                            <img
                                                src={image}
                                                alt={`Slide ${index}`}
                                                className="img-fluid"
                                            />
                                            <div className="carousel-caption d-none d-md-block"></div>
                                        </CarouselItem>
                                    ))}
                                    <a
                                        className="carousel-control-prev"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            previous();
                                        }}
                                        role="button"
                                    >
                                        <i className="now-ui-icons arrows-1_minimal-left"></i>
                                    </a>
                                    <a
                                        className="carousel-control-next"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            next();
                                        }}
                                        role="button"
                                    >
                                        <i className="now-ui-icons arrows-1_minimal-right"></i>
                                    </a>
                                </Carousel>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer */}
                <DefaultFooter />
            </div>
        </>
    );
};

export default DcarePage;
